export const STORAGE_KEYS = {
  RESIDENTS: 'packageRoom_cachedResidents',
  WEEKLY_CODE: 'packageRoom_weeklyCode',
  WEEKLY_CODE_TIMESTAMP: 'packageRoom_weeklyCodeTimestamp',
  PACKAGE_SESSIONS: 'packageRoom_packageSessions',
  LAST_SYNC_TIMESTAMP: 'packageRoom_lastSyncTimestamp',
  SETTINGS: 'packageRoom_settings',
  SETTINGS_TIMESTAMP: 'packageRoom_settingsTimestamp',
  LAST_RELOAD_DATE: 'packageRoom_lastReloadDate',
}

export const anonymizeName = (fullName) => {
  const nameParts = fullName.trim().split(/\s+/)

  if (nameParts.length === 0) {
    return ''
  }

  if (nameParts.length === 1) {
    return nameParts[0]
  }

  const firstName = nameParts[0]
  const lastNameInitial = nameParts[nameParts.length - 1][0].toUpperCase()

  return `${firstName} ${lastNameInitial}.`
}

const RONE_RESIDENCES_BUILDING_NAME = 'Rone Residences'

export const isRoneResidencesBuilding = (buildingName) =>
  buildingName === RONE_RESIDENCES_BUILDING_NAME
